module.exports = __webpack_public_path__ + "img/iPadHands.a423b409.jpg";